import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sn-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
  styleUrls: ['./timeout-dialog.component.scss'],
})
export class TimeoutDialogComponent implements OnInit, OnDestroy {
  public message: string;
  public title: string;
  public timeout: number;
  public timeLeft: number;

  private readonly _cancel$ = new Subject<void>();
  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public config: {
      title: string;
      message: string;
      timeout: number;
    },
    private readonly _dialogRef: MatDialogRef<TimeoutDialogComponent>,
  ) {
    this.title = config.title || 'Please Confirm';
    this.timeout = config.timeout || 30 * 1000;
    this.message = config.message || 'Your session is about to expire.';
  }

  public ngOnInit(): void {
    timer(0, 1000)
      .pipe(takeUntil(this._cancel$), takeUntil(this._destroy$))
      .subscribe((time) => {
        this.timeLeft = (this.timeout - time * 1000) / 1000;
        if (this.timeLeft <= 0) {
          this._dialogRef.close();
        }
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._cancel$.next();
    this._cancel$.complete();
  }

  public continue(): void {
    this._dialogRef.close(true);
  }

  public end(): void {
    this._dialogRef.close(false);
  }
}
